module.exports = __webpack_public_path__ + "static/Virtual-8f7d03b6556c864c1276dc48512f008f.png";